import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import AdminHeader from '../../components/admin/common/AdminHeader'
import AdminFooter from '../../components/admin/common/AdminFooter'
import AdminSidebar from '../../components/admin/common/AdminSidebar'

const AdminpageLayout = () => {

  // 관리자 css, js 로드
    useEffect(() => {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = "/styles/sb-admin.css"
      document.head.appendChild(link)
  
      const scriptTag = document.createElement("script")
      scriptTag.src = "/js/sb-admin.js"
      document.head.appendChild(scriptTag)
  
      return () => {
        document.head.removeChild(link)
        document.head.removeChild(scriptTag)
      }
    }, []);

  return (
    <div>
      <div id="wrapper">
        {/* Sidebar */}
        <AdminSidebar />

        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            {/* Topbar */}
            <AdminHeader />

            {/* Main */}
            <main>
              <Outlet />
            </main>

          </div>

          {/* Footer */}
          <AdminFooter />
        </div>
      </div>
    </div>
  )
}

export default AdminpageLayout
